import { useState } from 'react';
import type { ReactNode } from 'react';

import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';

const PUBLIC_TOKEN = '';

interface Props {
  children: ReactNode;
  currentUserEmail?: string;
  groupId: string;
  originalUrl: string;
  translations?: Record<string, string>;
}

export default function RootMeButton({
  children,
  currentUserEmail,
  groupId,
  originalUrl,
  translations = {},
}: Props) {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [message, setMessage] = useState('');

  const handleClickToRedirect = async () => {
    setIsRedirecting(true);
    setMessage('');

    const apiUrl = `https://root-me.pro/api/v1/groups/${groupId}/invite`;
    const requestBody = {
      email: currentUserEmail,
      role: 'student',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          authorization: `Bearer ${PUBLIC_TOKEN}`,
          'content-type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (response.status === 422) {
        setMessage(translations.invitation_already_sent);
        window.open(originalUrl, '_blank');
        setIsRedirecting(false);
        return;
      }

      if (response.ok) {
        setMessage(translations.invitation_sent);
      } else {
        setMessage(`${response.status} ${response.statusText}`);
      }
      // eslint-disable-next-line no-empty
    } catch (error) {}

    setIsRedirecting(false);
  };

  return (
    <>
      <Button isLoading={isRedirecting} variant="primary" onClick={handleClickToRedirect}>
        {children}
      </Button>

      {message && <Typography sx={{ display: 'block', marginTop: 2 }}>{message}</Typography>}
    </>
  );
}
